import { render } from "./B2bPageCmrEmit.vue?vue&type=template&id=a2620a8c&scoped=true&lang=pug"
import script from "./B2bPageCmrEmit.vue?vue&type=script&lang=js"
export * from "./B2bPageCmrEmit.vue?vue&type=script&lang=js"

import "./B2bPageCmrEmit.vue?vue&type=style&index=0&id=a2620a8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2620a8c"]])

export default __exports__